import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MasterDataCommon } from '../master-data.common';
import { MasterDataService } from 'src/app/services/master-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-manage-d-role',
  templateUrl: './manage-d-role.component.html',
  styleUrls: ['./manage-d-role.component.css']
})
export class ManageDRoleComponent implements OnInit {
  modalFormObjList:any;
  modalForm:any;
  modalStatus:any;
  formSubmitted=false;
  formErrors = MasterDataCommon.assignmentFormErrors;
  formValidationMessages = MasterDataCommon.assignmentFormValidationMessages;

  constructor(private masterDataService:MasterDataService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadRoles();
  }

  loadRoles(){
    this.masterDataService.getRoles()
    .subscribe(res => {
      console.log(res);
      this.modalFormObjList = res;
    });
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      id:[''],
      name :  ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content,status) {
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  onDeleteClick(item){
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
       this.modalStatus = 'delete';
       this.masterDataService.deleteRole(item.id)
       .subscribe(resp => {
        console.log(resp);
        this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
  }

  onSaveClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.saveRole(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.closeModal();
        this.changeModalFormObjList(resp);
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
      })
    }
  }

  // ----------------------------

  setValueToModalForm(modalObj){
    console.log(modalObj);
    this.modalForm.patchValue({
      id:modalObj.id,
      name: modalObj.name,
    });
    console.log(this.modalForm.value)
  }


  onEditClick(modalContent,formObj){
    console.log(formObj);
    this.setValueToModalForm(formObj);
    this.openModal(modalContent,'edit');
  }

  onUpdateClick(){
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.updateRole(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.changeModalFormObjList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
      })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj){
    if(this.modalStatus=='add'){
      this.modalFormObjList.push(modalFormObj);
    }
    if(this.modalStatus=='edit'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if(this.modalStatus=='delete'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }


  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
